module.exports = __webpack_public_path__ + "static/media/scifi.94577151.png";